<script setup>
import { onMounted } from "vue";
import { useI18n } from "vue-i18n";

const props = defineProps({
    title: String,
    href: String,
});

const { t: __ } = useI18n();

onMounted(() => {
    if (!document.getElementById("oto-facebook-script")) {
        let facebookScript = document.createElement("script");
        facebookScript.id = "oto-facebook-script";
        facebookScript.setAttribute("src", "https://connect.facebook.net/en_US/sdk.js#xfbml=1&version=v3.2");
        facebookScript.setAttribute("async", true);
        facebookScript.setAttribute("defer", true);
        document.head.appendChild(facebookScript);
    }
});
</script>
<template>
    <div v-if="props.href" style="display: block">
        <div id="fb-root"></div>
        <div class="fb-post" :data-href="href" data-width="500" data-show-text="true"></div>
    </div>
</template>
